import styled from 'styled-components'
import { css } from '@styled-system/css'
import H1 from '../../../ui/bend/typography/H1'
import { H3, Tabs, H5, GridItem } from 'ui/bend'
import { Flex, P, MainContainer, Button } from '../../../ui/acro'
const img = require('../../../../assets/images/alo-moves.png')

export const MyPracticeBox = styled('div')(() =>
  css({
    width: '100%',
    display: 'block',
    textAlign: 'center',
    padding: ['50px 0', '85px 0'],
    background: '#FAFAFA'
  })
)

export const Title = styled(H1)((props) =>
  css({
    textAlign: 'center',
    marginBottom: ['10px', '10px'],
    fontSize: ['38px', '48px'],
    lineHeight: ['48px' , '56px'],
    letterSpacing: ['-1.14px' , '-1.44px'],
    fontWeight:'600',
    fontFamily: props.theme.fonts.Proxima,
    color: props.theme.colors.primary
    
  })
)

export const StyledTab = styled(Tabs)((props) =>
  css({
    width: 'auto',
    justifyContent: 'center',
    '::before': {
      background: 'none'
    },
    span: {
      fontSize: ['14px', '18px'],
      fontFamily: props.theme.fonts.Proxima,
      lineHeight: ['135%' , '24px'],
      letterSpacing: ['0.8px', '0.9px'],
      fontWeight:'700'
    }
  })
)

export const Container = styled(Flex)(() =>
  css({
    flexDirection: 'column',
    alignItems: 'center',
    backgroundImage: `url('${img}')`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: ['300px', '350px', '400px', '550px'],
    paddingTop: '45px',
    marginTop: '1rem',
    backgroundSize: 'contain'
  })
)

export const Subtitle = styled(P)((props) =>
  css({
    fontSize: ['16px', '18px'],
    fontWeight: '400',
    letterSpacing: '2px',
    lineHeight: '24px',
    letterSpacing: ['0.352px' , '0.396px'],
    textAlign: 'center',
    textTransform: 'uppercase',
    fontFamily: props.theme.fonts.Proxima
  })
)

export const StyledText = styled(H3)(() =>
  css({
    fontSize: ['18px', '25px', '30px', '35px'],
    letterSpacing: '2.5px',
    lineHeight: '40px',
    color: '#A9A9A9',
    fontFamily: 'Proxima',
    fontWeight: '500',
    textTransform: 'uppercase'
  })
)

export const FindLink = styled(P)(() =>
  css({
    fontSize: '16px',
    letterSpacing: '2.5px',
    lineHeight: '25px',
    textTransform: 'uppercase',
    fontFamily: 'Proxima',
    fontWeight: '500',
    textDecoration: 'underline 1px',
    textUnderlineOffset: '0.7em',
    zIndex: 1,
    paddingTop: '10px'
  })
)

export const SeriesBox = styled(Flex)(() =>
  css({
    flexWrap: 'wrap',
    margin: ['none', 'none', '0 -25px', '0 -25px'],
    width: ['90%', 'unset']
  })
)

export const SeeMoreButton = styled(P)(() =>
  css({
    cursor: 'pointer',
    color: 'black',
    textDecorationLine: 'underline',
    textUnderlineOffset: '0.5em',
    fontWeight: '500',
    fontSize: '16px',
    textTransform: 'uppercase',
    fontFamily: 'Proxima',
    padding: '20px',
    letterSpacing: '2.5px',
    lineHeight: '25px',
    ':hover': {
      color: 'black',
      fontWeight: '500',
      fontSize: '16px',
      textDecorationThickness: '1.8px',
      textTransform: 'uppercase'
    }
  })
)

export const stylesSubtitle = {
  letterSpacing: '1px',
  fontSize: '16px',
  color: ' black',
  lineHeight: '22px',
  display: ['none', 'none', 'block', 'block']
}

export const TableContainer = styled(MainContainer)(() =>
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  })
)

export const rows = styled('td')(() =>
  css({
    display: 'grid',
    gridTemplateRows: 'repeat(6, 1fr)',
    gridGap: '10px',
    borderTop: ' 1px solid black',
    padding: '10px'
  })
)

export const table = styled('table')(() =>
  css({
    display: 'grid',
    gridTemplateRows: ' repeat(6, 1fr)',
    gridGap: '10px',
    border: '1px solid black',
    padding: '10px'
  })
)

export const TableText = styled(GridItem)(() =>
  css({
    fontFamily: 'Proxima-Nova',
    color: 'black',
    fontWeight: '500',
    lineHeight: '16px',
    fontSize: '16px',
    padding: ['0 0 0 14px', '20px 10px 20px 0'],
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  })
)

export const TableLink = styled(GridItem)(() =>
  css({
    fontFamily: 'Arquitecta',
    color: 'black',
    textTransform: 'uppercase',
    letterSpacing: ['1px', '1.5px'],
    fontWeight: '500',
    lineHeight: '19px',
    fontSize: '16px'
  })
)

export const CheckIcon = styled('div')(() =>
  css({
    fontFamily: 'arial'
  })
)

export const ShareBtn = styled(Button)(() =>
  css({
    fontFamily: 'Proxima-Nova',
    fontSize: '15px',
    lineHeight: '21px',
    borderRadius: '0',
    fontWeight: 'normal',
    minWidth: '280px',
    minHeight: '30px',
    textTransform: 'capitalize',
    justifyContent: 'start',
    paddingTop: '5px'
  })
)

export const ToolTip = styled('div')((props) =>
  css({
    fontFamily: 'Arquitecta',
    fontSize: '11px',
    fontWeight: 'normal',
    minWidth: '380px',
    minHeight: '30px',
    textTransform: 'capitalize lowercase',
    color: 'white',
    borderRadius: '25px',
    padding: '5px',
    letterSpacing: '1.5px',
    boxShadow: props ? props.boxShadow : ''
  })
)

export const ToolTipSmall = styled(Flex)((props) =>
  css({
    fontFamily: 'Arquitecta',
    fontSize: '16px',
    minWidth: '200px',
    minHeight: '40px',
    textTransform: 'capitalize lowercase',
    color: 'white',
    borderRadius: '25px',
    padding: '5px',
    letterSpacing: '1.5px',
    boxShadow: props ? props.boxShadow : '',
    alignItems: 'center',
    justifyContent: 'center'
  })
)

export const MoreContent = styled('div')(() =>
  css({
    display: 'block',
    position: 'absolute',
    marginBottom: '5px'
  })
)

export const MoreIcon = styled.div`
   {
    position: relative;
    bottom: 5px;
    right: 0.8px;
  }
`

export const RoundedContainer = styled(Flex)((props) =>
  css({
    padding: props.padding ? props.padding : '13px 10px 10px 10px',
    backgroundColor: props.backgroundColor ? props.backgroundColor : '#d9d9d9',
    width: props.width ? props.width : '25px',
    height: props.height ? props.height : '25px',
    alignSelf: 'center',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    color: props.color ? props.color : 'black',
    fontSize: props.fontSize ? props.fontSize : '16px',
    fontWeight: props.fontWeight ? props.fontWeight : 'normal',
    border: props.border ? props.border : '',
    ':hover': {
      transform: props.transform ? props.transform : '',
      animation: 'three 3s infinite',
      transition: '0.3s all ease 0s',
      color: props ? props.hoverColor : '',
      border: props ? props.borderHover : ''
    }
  })
)

export const popUpStyle = {
  title: {
    fontSize: '20px',
    fontFamily: 'Arquitecta',
    fontWeight: 'normal',
    letterSpacing: '2.5px'
  },
  leftBtn: {
    textDecoration: 'none',
    fontFamily: 'Arquitecta',
    textTransform: 'uppercase',
    letterSpacing: '2.5px',
    color: '#a9a9a9',
    fontWeight: '500',
    border: 'none'
  },
  rightBtn: {
    borderRadius: '0'
  },
  bodyText: {
    width: '100%',
    backgroundColor: '#f5f5f5',
    color: '#000',
    border: '0',
    fontSize: '13px',
    letterSpacing: '1.25px',
    textAlign: 'left',
    lineHeight: '19px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    height: '40px'
  },
  modalSize: {
    height: '18em',
    borderRadius: '10px',
    maxWidth: '35em'
  },
  btnContainer: {
    borderTop: '1px solid #e5e5e5',
    paddingTop: '1.5em',
    justifyContent: 'flex-end',
    rowGap: '8px'
  }
}

export const MainTable = styled(Flex)(() => {
  css({
    width: '90%',
    margin: 'auto'
  })
})

export const SelectComponent = styled('select')(() => {
  css({
    border: 'none',
    color: '#999999',
    fontFamily: 'Arquitecta',
    letterSpacing: '0.9px',
    fontSize: '15px'
  })
})

export const Option = styled('option')(() => {
  css({
    color: '#999999',
    fontFamily: 'Arquitecta',
    letterSpacing: '0.9px',
    fontSize: '15px'
  })
})

export const TableTitle = styled(H5)((props) =>
  css({
    paddingBottom: '10px',
    justifyContent: 'space-around',
    color: '#a9a9a9',
    paddingTop: '20px',
    paddingLeft: '0',
    textTransform: 'uppercase',
    fontWeight: props ? props.fontWeight : '500',
    letterSpacing: '2.5px',
    fontSize: '20px',
    cursor: 'pointer',
    fontFamily: 'Arquitecta',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  })
)

export const SortBtn = styled(Button)(() =>
  css({
    minWidth: '10px',
    background: 'none',
    color: '#a9a9a9',
    minHeight: '20px',
    padding: '0 10px 10px 5px',
    width: '10px',
    height: '10px',
    ':hover': {
      background: 'none'
    }
  })
)
export const SortBtnDown = styled(Button)(() =>
  css({
    fontSize: '25px',
    minWidth: '10px',
    background: 'none',
    color: '#a9a9a9',
    minHeight: '20px',
    padding: '0 0 10px 15px',
    width: '10px',
    height: '10px',
    ':hover': {
      background: 'none'
    }
  })
)

export const SeriesTitle = styled(P)(() =>
  css({
    position: 'absolute',
    top: '30px',
    textAlign: 'left',
    background: '#fff',
    zIndex: '1',
    padding: [
      '0.8rem 2.5rem',
      '0.8rem 2.5rem',
      '0.8rem 1.5rem',
      '0.8rem 1.5rem'
    ],
    textTransform: 'uppercase',
    fontFamily: 'Arquitecta',
    letterSpacing: '2px',
    fontSize: ['0.4vw', '0.5vw', '0.6vw', '0.8vw'],
    fontWeight: '500',
    display: ['none', 'none', 'none', 'block']
  })
)

export const BoxInfo = styled('span')(() =>
  css({
    position: 'relative',
    top: '15px',
    right: '10px',
    background: 'gray',
    zIndex: '1',
    textTransform: 'uppercase',
    fontFamily: 'Arquitecta',
    letterSpacing: '2px',
    color: 'white',
    fontWeight: '500',
    display: ['none', 'none', 'none', 'block'],
    padding: [
      '0.1rem 1.3rem',
      '0.2rem 1.3rem',
      '0.2rem 1.4rem 0.2rem 0.8rem',
      '0.2rem 1.6rem'
    ],
    fontSize: ['12px', '12px', '14px', '14px'],
    verticalAlign: 'top',
    height: '1.6em',
    lineHeight: '1 em'
  })
)
